import React from 'react'
import { Link } from 'react-router-dom'
import "./Header.css"
import { useTheme } from '../contexts/ThemeContext'

const Header = ({active, setActive, user, isAdmin, handleLogout}) => {
    const userId = user?.uid;
    const { theme, toggleTheme } = useTheme();
    
    return (
        <nav className="navbar">
            <div className="container">
                <Link to="/" className="navbar-brand" onClick={() => setActive("home")}>
                    UJVAL.TECH
                </Link>

                <div className="nav-links">
                    <Link
                        to="/about"
                        className={`nav-link ${active === "about" ? "active" : ""}`}
                        onClick={() => setActive("about")}
                    >
                        About
                    </Link>

                    {userId ? (
                        <>
                            {isAdmin && (
                                <Link
                                    to="/create"
                                    className={`nav-link ${active === "create" ? "active" : ""}`}
                                    onClick={() => setActive("create")}
                                >
                                    Create
                                </Link>
                            )}
                            <Link
                                to="/account"
                                className={`nav-link ${active === "account" ? "active" : ""}`}
                                onClick={() => setActive("account")}
                            >
                                Account
                            </Link>
                            <button
                                className="theme-toggle-btn"
                                onClick={toggleTheme}
                                aria-label={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
                            >
                                {theme === 'light' ? '🌙' : '☀️'}
                            </button>
                            <Link
                                to="/auth"
                                className="nav-link"
                                onClick={handleLogout}
                            >
                                Logout
                            </Link>
                        </>
                    ) : (
                        <>
                            <button
                                className="theme-toggle-btn"
                                onClick={toggleTheme}
                                aria-label={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
                            >
                                {theme === 'light' ? '🌙' : '☀️'}
                            </button>
                            <Link
                                to="/auth"
                                className={`nav-link ${active === "login" ? "active" : ""}`}
                                onClick={() => setActive("login")}
                            >
                                Login
                            </Link>
                        </>
                    )}
                </div>
            </div>
        </nav>
    )
}

export default Header